// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3cO1c","fileBtn":"File_fileBtn__3etMB","closeBtn":"File_closeBtn__111z5","fileSelected":"File_fileSelected__3EWm6","disabled":"File_disabled__3c5Fe"};